"use client";

import { useSyncExternalStore } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";

function subscribe(callback: () => void) {
  const mq = window.matchMedia(QUERY);
  mq.addEventListener("change", callback);
  return () => mq.removeEventListener("change", callback);
}

function getSnapshot() {
  return window.matchMedia(QUERY).matches;
}

/** Motion allowed on the server / during hydration; the client snapshot takes
 *  over immediately after. */
function getServerSnapshot() {
  return false;
}

/**
 * Tracks the user's "reduce motion" OS/browser setting so animated UI can fall
 * back to instant state changes. Implemented with `useSyncExternalStore` so the
 * subscription lives outside React state (no setState-in-effect) and stays in
 * sync if the preference flips.
 */
export function usePrefersReducedMotion(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
